import http from "plugins/axios";

export default {
  getSymbolList(data) {
    return http.get({
      url: "/ta/admin/tenant/symbol/getSymbolList",
      data,
    });
  },
  // 合约
  getContractSymbolPage(data) {
    return http.get({
      url: `/ta/admin/tenant/contractSymbol/getContractSymbolPage`,
      data,
    });
  },

  updateContractSymbol(data) {
    return http.post({
      url: `/ta/admin/tenant/contractSymbol/updateContractSymbol`,
      data,
    });
  },

  // 现货
  getSpotSymbolPage(data) {
    return http.get({
      url: `/ta/admin/tenant/spotSymbol/getSpotSymbolPage`,
      data,
    });
  },

  updateSpotSymbol(data) {
    return http.post({
      url: `/ta/admin/tenant/spotSymbol/updateSpotSymbol`,
      data,
    });
  },

  updateContractSymbolPriceRate(data) {
    return http.post({
      url: `/ta/admin/tenant/contractSymbol/updateContractSymbolPriceRate`,
      data,
    });
  },

  // copy
  copytradeCof(data) {
    return http.get({
      url: `/ta/admin/tenant/copytrade/config/get`,
      data,
    });
  },
  copytradeUpdte(data) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/config/update`,
      data,
    });
  },

  copytradeLabel(data) {
    return http.get({
      url: `/ta/admin/tenant/copytrade/config/label-list`,
      data,
    });
  },

  deleteLabel(data) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/config/delete-label`,
      data,
      dataType: "form",
    });
  },
  addLabel(data) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/config/add-label`,
      data,
    });
  },

  copytradeSymblList(data) {
    return http.get({
      url: `/ta/admin/tenant/copytrade/symbol/config/list`,
      data,
    });
  },

  copytradeLeaderList(data) {
    return http.get({
      url: "/ta/admin/tenant/copytrade/leader/list",
      data,
    });
  },

  copytradeLevelList(data) {
    return http.get({
      url: "/ta/admin/tenant/copytrade/leader/level/list",
      data,
    });
  },
  copytradeLeaderAudit(data) {
    return http.post({
      url: "/ta/admin/tenant/copytrade/leader/audit",
      data,
    });
  },

  copytradeAuditLog(data) {
    return http.get({
      url: "/ta/admin/tenant/copytrade/leader/audit/record",
      data,
    });
  },

  copytradeLeaderTermination({ id }) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/leader/termination/${id}`,
    });
  },

  copytradeLeaderDowngrading({ id }) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/leader/downgrading/${id}`,
    });
  },

  copytradeLeaderLevelAdd(data) {
    return http.post({
      url: "/ta/admin/tenant/copytrade/leader/level/add",
      data,
    });
  },
  copytradeLeaderLevelEdit(data) {
    return http.post({
      url: "/ta/admin/tenant/copytrade/leader/level/edit",
      data,
    });
  },
  copytradeLeaderLevelDel({ id }) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/leader/level/del/${id}`,
    });
  },

  copytradeFollowList(data) {
    return http.get({
      url: "/ta/admin/tenant/copytrade/follower/list",
      data,
    });
  },

  copytradeOrderHistory(data) {
    return http.get({
      url: "/ta/admin/tenant/copytrade/order/order-history",
      data,
    });
  },

  copytradeConfAdd(data) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/symbol/config/add`,
      data,
    });
  },

  copytradeConfUpdate(data) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/symbol/config/update`,
      data,
    });
  },

  copytradeConfOff({ id }) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/symbol/config/off/${id}`,
    });
  },

  copytradeConfOn({ id }) {
    return http.post({
      url: `/ta/admin/tenant/copytrade/symbol/config/on/${id}`,
    });
  },

  copytradeFollowerStat(data) {
    return http.get({
      url: `/ta/admin/tenant/copytrade/stat/followerStat`,
      data,
    });
  },

  copytradeLeaderStat(data) {
    return http.get({
      url: `/ta/admin/tenant/copytrade/stat/leaderStat`,
      data,
    });
  },

  // 设置交易员等级
  setLeaderLevel(data) {
    return http.post({
      url: "/ta/admin/tenant/copytrade/leader/setLeaderLevel",
      params: data,
    });
  },
  // 交易员审核列表
  getLeaderAuditList(data) {
    return http.get({
      url: "/ta/admin/tenant/copytrade/leader/profile/list",
      data,
    });
  },
  // 头像昵称审核
  getLeaderProfileAudit(data) {
    return http.post({
      url: "/ta/admin/tenant/copytrade/leader/profile/audit",
      data,
    });
  },
  // 头像昵称审核记录
  getLeaderProfileAuditRecord(data) {
    return http.get({
      url: "/ta/admin/tenant/copytrade/leader/profile/record",
      data,
    });
  },
};
